const initialState = {
    category: {code:'machines'},
    range: null,
    filters: [],
    filtersList: [],
    sort:'name/1',
    selectedView:'card',
    activeCategories:[],
    results:[],
    total:0,
    firstLoad:true,
    marketFilter : null,
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key =>
            {
                if(key!=="marketFilter") state[key] = s[key]
            }
            )
        },
        setCategory(state, value) {
            state.category = value;
            state.firstLoad = true;
        },
        setRange(state, value) {
            state.range = value;
        },
        setMarketFilter(state, value) {
            state.marketFilter = value;
        },
        setFilters(state, value) {
            state.filters = value;
        },
        setFiltersList(state, value) {
            state.filtersList = value;
        },
        setSort(state, value) {
            state.sort = value;
        },
        setTotal(state, value) {
            state.total = value;
        },
        setView(state, value) {
            state.selectedView = value;
        },
        setActiveCategories(state, value) {
            state.activeCategories = value;
        },
        setResults(state, value) {
            state.results = value;
        },
        setFirstLoad(state, value) {
            state.firstLoad = value;
        },
        deleteFilter(state, index) {
            state.filters.splice(index, 1);
        },
        deleteFilters(state) {
            state.filters = [];
        },
        deleteFiltersList(state) {
            state.filtersList = [];
        }
    }
};
